import React, { useState } from 'react';
import { styled } from '@mui/system';

import Dialog from '@mui/material/Dialog';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 


const theme = createTheme();

const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));

const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#eaf7fdcc",
}));

const ProjectStatus = (props) => {
  const [open, setOpen] = React.useState(props.editing);
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState('xs');

  const [projectStat, setProjectStat] = useState('');
  const [projectId] = useState(props.pojectStat.projectId);

  const handleClose = () => {
    setOpen(false);
    props.setEditing(false);
  };

  const handleStatus = (e) => {
    setProjectStat(e.target.value);
  };

  return (
    <ThemeProvider theme={theme}>
    <div>
    <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          style={{}}
        >
          <CustomDialogTitle onClose={handleClose}>
          <p style={{ fontSize: '1.5em' }}>Project Status</p>
          </CustomDialogTitle>
          <CustomDialogContent dividers>
          <form
            className='form-horizontal '
            style={{ backgroundColor: '#eaf7fdcc' }}
            onSubmit={(event) => {
              event.preventDefault();
              if (projectStat === '') {
                toast.error('Please select the status', {
                  position: 'top-right',
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              } else {
                props.editStatusDetails(projectId, projectStat);
                props.setEditing(false);
                setOpen(false);
              }
            }}
          >
            <div className='form-group'>
              <ToastContainer
                position='top-right'
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                className=''
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              <div className='col-md-12'>
                <select className='form-control' onChange={handleStatus}>
                  <option value='' selected disabled>
                    Select Status
                  </option>

                  <option value='Work In Progress'>Work In Progress</option>
                  <option value='Completed'>Completed</option>
                </select>
              </div>
            </div>

            <div className='form-group'>
              <div className='col-sm-offset-2 col-sm-10'>
                <button
                  style={{ marginLeft: '35%', marginTop: '5%' }}
                  onClick={handleClose}
                  type='button'
                  className='btn muted-button  deca-btn-orange a-btn-cancel'
                >
                  Cancel
                </button>

                <button
                  className='btn btn-secondary deca-btn-yellow a-update-email-alert'
                  style={{ marginLeft: '2%', marginTop: '5%' }}
                >
                  Update Status
                </button>
              </div>
            </div>
          </form>
        </CustomDialogContent>
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default ProjectStatus;
